import React, {
  createContext,
  useContext,
  useCallback,
  useReducer,
} from "react";

/**
 * Import Packages
 */
import { collection } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";

/**
 * Import Hooks
 */
import { useFirestore } from "./FirestoreProvider";

/**
 * Import Reducers
 */
import {
  roomsReducer,
  clearRoom,
  initialState,
  setRoomByAccessCode,
} from "../reducers/RoomsReducer";

/**
 * Create Context for Provider
 */
export const RoomsContext = createContext();

/**
 * Hook for Rooms Context
 *
 * @returns Context
 */
export function useRooms() {
  return useContext(RoomsContext);
}

/**
 *
 * @param {Object} props
 * @returns
 */
export const RoomsProvider = ({ children }) => {
  /**
   * Get our database
   */
  const { db } = useFirestore();

  /**
   * Use Firestore collection data to get Rooms
   */
  const [rooms, loading, error] = useCollection(collection(db, "rooms"), {
    idField: "id",
    snapshotListenOptions: { includeMetadataChanges: true },
  });
  // const [rooms, loading, error] = useCollectionData(collection(db, "rooms"), {
  //   idField: "id",
  //   snapshotListenOptions: { includeMetadataChanges: true },
  // });

  /**
   * Create roomState & roomDispatch for local data
   */
  const [roomsState, roomsDispatch] = useReducer(
    roomsReducer,
    initialState
    // initializer
  );

  /**
   * Retrieve data for specific room, comparing room state against rooms array
   */
  const getRoomsData = useCallback(() => {
    if (!rooms) {
      return [];
    }

    return rooms.docs
      .find((element) => element.accessCode === roomsState.accessCode)
      .data();
  }, [rooms, roomsState]);

  /**
   * Every time the roomState or rooms change, update local storage
   */
  // useEffect(() => {
  //   localStorage.setItem("localRoom", JSON.stringify(roomsState));
  // }, [roomsState, rooms]);

  /**
   *
   */
  return (
    <RoomsContext.Provider
      value={{
        rooms,
        loading,
        error,
        roomsState,
        roomsDispatch,
        getRoomsData,
        setRoomByAccessCode,
        clearRoom,
      }}
    >
      {children}
    </RoomsContext.Provider>
  );
};
